// import { useEffect, useState } from "react";
// import { apiRequestGet } from "../../../lib/common/api";
import { TTestimonial } from "../../../lib/types/testimonials";
// import { useFileManagement } from "../../../services/file-management";

// API integration retained for reactivation. Manual testimonials are used for now.
/*
const useTestimonials = () => {
    const [testimonials, setTestimonials] = useState<TTestimonial[]>([]);
    const [peopleImages, setPeopleImages] = useState<{
        [userId: string]: string;
    }>({});

    const { getImagePath } = useFileManagement();

    const getTestimonials = async () => {
        const testimonials = await apiRequestGet<{
            testimonials: TTestimonial[];
        }>("/testimonials/all");
        return testimonials.data;
    };

    useEffect(() => {
        getTestimonials().then((data) => {
            setTestimonials(data.testimonials);
            const images = data.testimonials.reduce(
                (prev, actual) => ({
                    ...prev,
                    [actual.user_id]: getImagePath("logo", "fixed", actual.user_id),
                }),
                {},
            );
            setPeopleImages(images);
        });
        //eslint-disable-next-line
    }, []);

    return {
        testimonials,
        peopleImages,
    };
};
*/

// Manually maintained testimonials supplied for the homepage.
const manualTestimonials: TTestimonial[] = [
    {
        user_id: "assistant",
        name: "Emily Carter — Dental Assistant",
        user_type: "tech",
        testimony:
            "I found a dentist who was looking for someone with my experience. The process was simple, and I’m happy to have found a position where I can keep learning.",
        main: false,
    },
    {
        user_id: "hygienist",
        name: "Marcus Reed — Dental Hygienist",
        user_type: "tech",
        testimony:
            "I was hoping to find a practice closer to home. Through WinWinGo, I connected with a dentist who was a great fit, and I’m excited about my new role.",
        main: false,
    },
    {
        user_id: "coordinator",
        name: "Jordan Brooks — Front Desk Coordinator",
        user_type: "tech",
        testimony:
            "After searching on my own for a while, I found a dental office that valued my patient-service experience. I’m grateful for the opportunity to start something new.",
        main: false,
    },
    {
        user_id: "receptionist",
        name: "Tyler Mitchell — Dental Receptionist",
        user_type: "tech",
        testimony:
            "I wanted to join a welcoming dental team, and I found a position that feels right for me. WinWinGo helped me take the next step in my career.",
        main: true,
    },
];

const useTestimonials = (): { testimonials: TTestimonial[]; peopleImages: Record<string, string> } => ({
    testimonials: manualTestimonials,
    peopleImages: {
        assistant: "/images/testimonials/emily-carter.jpg",
        hygienist: "/images/testimonials/marcus-reed.jpg",
        coordinator: "/images/testimonials/jordan-brooks.jpg",
        receptionist: "/images/testimonials/tyler-mitchell.jpg",
    },
});

type TTestimonyProp = {
    testimony: TTestimonial;
    imageURL: string;
};
const Testimony = (props: TTestimonyProp) => {
    const { testimony, imageURL } = props;
    const [name, role] = testimony.name.split(" — ");

    return (
        <>
            <div className="container testimony-text p-4 h-100">
                <blockquote className="blockquote h-100 d-flex flex-column">
                    <p className="small mb-4" data-testid="testimony-test">
                        {testimony.testimony}
                    </p>
                    <footer className="testimonial-author mt-auto">
                        <img className="testimonial-picture float-start me-3" src={imageURL} alt="" data-testid="photo-test" />
                        <div className="overflow-hidden">
                            {role && <span className="testimonial-role d-block">{role}</span>}
                            <span className="testimonial-name d-block">{name}</span>
                        </div>
                    </footer>
                </blockquote>
            </div>
        </>
    );
};

export const Testimonials = () => {
    const { testimonials, peopleImages } = useTestimonials();

    return (
        <>
            {/*<div className="container-fluid testimonials">
                <div className="row">
                    <div className="col-md-12">
                        <img alt="testimonials" src="images/global/testimonials.jpg" style={{ maxWidth: "100%", height: "auto" }} />
                    </div>
                </div>
            </div > */}
            {testimonials.length > 0 && (
                <div className="container-fluid section-testimonials p-5 m-0">
                    <div className="container text-center mt-4 mt-md-5 mb-4 text-wrap">
                        <h1>Their next chapter started here</h1>
                        <p className="text-primary fw-bold mx-auto mb-0 testimonials-intro">
                            Hear from dental professionals who found their next role with a dentist through WinWinGo.
                        </p>
                    </div>
                    <div className="container">
                        <div className="row g-4 pt-3 pb-4 text-left">
                            <div className="col-md-6 testimony-section">
                                <Testimony imageURL={peopleImages[testimonials[0].user_id]} testimony={testimonials[0]} />
                            </div>
                            <div className="col-md-6 testimony-section">
                                <Testimony imageURL={peopleImages[testimonials[1].user_id]} testimony={testimonials[1]} />
                            </div>
                            <div className="col-md-6 testimony-section">
                                <Testimony imageURL={peopleImages[testimonials[2].user_id]} testimony={testimonials[2]} />
                            </div>
                            <div className="col-md-6 testimony-section">
                                <Testimony imageURL={peopleImages[testimonials[3].user_id]} testimony={testimonials[3]} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
